<div class="dropdown-search-container" [ngClass]="{'disabled': disabled, 'schwab-edit-icon-right': editIconOnHover && !this.searchString && !disabled, 'dropdown-search-container-not-disabled': !disabled}">
  <input type="text" pInputText [formControl]="inputControl" #input [placeholder]="placeholder" [size]="size"
    (keyup)="onKeyUp($event)" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
    hoverPanel [hoverPanelTemplate]="panel" [hoverPanelZIndex]="hoverPanelZIndex"
    (hoverPanelClose)="onHoverPanelClose()" [hoverPanelWidth]="hoverPanelWidth"
    tooltip [tooltipTitle]="inputControl.value" [tooltipRequiresTruncation]="true" [tooltipRequiresSafe]="true"/>
  @if (searchString?.length > 0 && !disabled) {
    <span class="material-icons close_icon dd-search-fa-times" (click)="clearInput()">clear</span>
  }
</div>

<ng-template #panel>
  <div [style.height]="gridHeight">
    <div class="ddsHoverPanel shadow" [ngStyle]="{width: hoverPanelWidth + 'px'}" #panelContent
      [class.hide]="!isVisible">
      <ag-grid-angular
        [style.width] = "'100%'"
        [style.height] = "gridHeight"
        #agGrid
        class="irb-dropdown-search"
        [suppressMovableColumns]="gridOptions.suppressMovableColumns"
        [suppressHorizontalScroll]="true"
        [suppressContextMenu]="true"
        [columnDefs]="gridOptions.columnDefs"
        [components]="frameworkComponents"
        (gridReady)="onGridReady($event)"
        [gridAutoHeight]="gridOptions.gridAutoHeight"
        [rowHeight]=30
        [headerHeight]="0"
        [overlayLoadingTemplate]="gridOptions.overlayLoadingTemplate"
        [overlayNoRowsTemplate]="gridOptions.overlayNoRowsTemplate"
        [rowSelection]="gridOptions.rowSelection"
        (rowClicked)="onRowClicked($event)"
        (cellClicked)="$event.event.stopPropagation()"
        >
      </ag-grid-angular>
      @if (showAddNewButton) {
        <div class="ddsm-add-new-button">
          <button class='btn-medium-secondary' (click)="addNewItemClick()">{{addNewItem.button}}</button>
        </div>
      }
    </div>
  </div>
</ng-template>
